import { Component, OnInit, Input } from '@angular/core';
import { ModalAlternativeService } from 'src/app/services/modal-alternative.service';
import { SesionService } from 'src/app/services/sesion.service';
import { ProductService } from 'src/app/services/product.service';

declare var $: any;

@Component({
    selector: 'app-modal-alternative',
    templateUrl: './modal-alternative.component.html',
    styleUrls: ['./modal-alternative.component.scss'],
    standalone: false
})
export class ModalAlternativeComponent implements OnInit {

  constructor( public content: ModalAlternativeService, public sesion: SesionService, public contenido: ProductService) {
  }

  ngOnInit() {
  }

}
